<template>
    <div>
        <div class="animate__animated animate__fadeIn">
            <div class="row">
                <div class="col-md-9">
                    <h4 class="font-weight-bold">Condições Educacionais</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Familiares" active>
                            <Familiares :item="item" />
                        </b-tab>
                        <b-tab title="Vulnerabilidades">
                            <Vulnerabilidades :item="item" />
                        </b-tab>
                        <b-tab :title="`Condicionalidades ${$t('PBF')}`">
                            <Condicionalidades :item="item" />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vulnerabilidades from "./educacao/Vulnerabilidade";
import Condicionalidades from "./educacao/Condicionalidade";
import Familiares from "./educacao/Familiares";
export default {
    components: { Vulnerabilidades, Condicionalidades, Familiares },
    props: ["item"],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style>
.spiner-counter {
    position: absolute;
    top: 0;
    right: 10px;
    margin-top: -0.7rem;
    width: 1.2rem;
    height: 1.2rem;
}
</style>
